import state from './moduleLoansState.js'
import mutations from './moduleLoansMutations.js'
import actions from './moduleLoansActions.js'
import getters from './moduleLoansGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}